// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__ACCYg","active":"Breadcrumbs_active__be+Qn","past":"Breadcrumbs_past__NBn5t","future":"Breadcrumbs_future__UlRbh","svg":"Breadcrumbs_svg__m9NLQ"};